var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThankyou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 420,
    viewBox: "0 0 430 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215 420C305.022 420 378 413.508 378 405.5C378 397.492 305.022 391 215 391C124.978 391 52 397.492 52 405.5C52 413.508 124.978 420 215 420Z",
    fill: "url(#paint0_linear_2561_10814)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M209.748 363.702C299.079 363.702 371.496 291.686 371.496 202.851C371.496 114.015 299.079 42 209.748 42C120.417 42 48 114.015 48 202.851C48 291.686 120.417 363.702 209.748 363.702Z",
    fill: "url(#paint1_linear_2561_10814)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2561_10814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.445 174.99V158.586C210.445 154.789 213.284 151.67 216.785 151.67C220.291 151.67 222.876 154.775 223.128 158.586C223.382 162.398 223.926 168.507 224.362 174.971",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.445 174.99V158.586C210.445 154.789 213.284 151.67 216.785 151.67C220.291 151.67 222.876 154.775 223.128 158.586C223.382 162.398 223.926 168.507 224.362 174.971",
    stroke: "#3D3D3D",
    strokeWidth: 1.67025,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.443 174.99V158.586C210.443 154.789 207.578 151.67 204.1 151.67C200.598 151.67 198.014 154.775 197.757 158.586C197.498 162.398 196.959 168.507 196.523 174.971",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.443 174.99V158.586C210.443 154.789 207.578 151.67 204.1 151.67C200.598 151.67 198.014 154.775 197.757 158.586C197.498 162.398 196.959 168.507 196.523 174.971",
    stroke: "#3D3D3D",
    strokeWidth: 1.67025,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.956 263.983C276.726 264.67 277.892 266.37 277.892 268.266V290.582C277.892 293.121 275.829 295.177 273.287 295.177H232.148C228.952 295.177 226.727 292.007 227.821 289.009L240.058 255.476C240.941 253.054 243.648 251.831 246.054 252.765L274.956 263.983Z",
    fill: "#D2DBF5",
    stroke: "#3D3D3D",
    strokeWidth: 1.67025,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.853 280.7L227.361 280.136C218.088 278.631 210.445 272.973 210.445 263.642V169.574C210.452 167.791 211.167 166.082 212.438 164.823C213.708 163.565 215.43 162.857 217.224 162.857C218.944 162.882 220.589 163.549 221.835 164.725C223.082 165.901 223.836 167.5 223.951 169.204C224.623 181.16 226.109 193.369 230.595 212.787C232.917 222.83 241.654 251.081 241.654 251.081L230.853 280.7Z",
    fill: "white",
    stroke: "#3D3D3D",
    strokeWidth: 1.67025,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.445 184.003H214.119C215.705 184.003 217.241 184.558 218.455 185.572C219.67 186.587 220.487 187.994 220.759 189.546L226.057 219.715",
    stroke: "#3D3D3D",
    strokeWidth: 1.67025,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.936 263.983C144.166 264.67 143 266.37 143 268.266V290.582C143 293.121 145.062 295.177 147.605 295.177H188.744C191.94 295.177 194.165 292.007 193.071 289.009L180.834 255.476C179.95 253.054 177.244 251.831 174.838 252.765L145.936 263.983Z",
    fill: "#D2DBF5",
    stroke: "#3D3D3D",
    strokeWidth: 1.67025,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.038 280.7L193.53 280.136C202.797 278.631 210.444 272.973 210.444 263.642V169.574C210.44 167.791 209.724 166.082 208.453 164.823C207.183 163.565 205.461 162.857 203.666 162.857C201.948 162.882 200.302 163.549 199.056 164.725C197.809 165.901 197.055 167.5 196.94 169.204C196.272 181.16 194.782 193.369 190.296 212.787C187.979 222.83 179.242 251.081 179.242 251.081L190.038 280.7Z",
    fill: "white",
    stroke: "#3D3D3D",
    strokeWidth: 1.67025,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.442 184.003H206.764C205.182 184.009 203.654 184.569 202.446 185.582C201.237 186.594 200.425 187.998 200.153 189.546L194.855 219.715",
    stroke: "#3D3D3D",
    strokeWidth: 1.67025,
    strokeMiterlimit: 10
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M211.484 132.461V110",
    stroke: "#3D3D3D",
    strokeWidth: 1.67025,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M245.5 164.291L268.046 162.649",
    stroke: "#3D3D3D",
    strokeWidth: 1.67025,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M179.765 164.291L157.223 162.649",
    stroke: "#3D3D3D",
    strokeWidth: 1.67025,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M237.848 142.034L249.661 122.886",
    stroke: "#3D3D3D",
    strokeWidth: 1.67025,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M184.83 142.034L173.012 122.886",
    stroke: "#3D3D3D",
    strokeWidth: 1.67025,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2128 113.235C69.341 112.156 70.9093 112.156 71.0377 113.235L72.1135 122.283C73.5026 133.967 82.7327 143.178 94.4398 144.565L103.506 145.638C104.587 145.766 104.587 147.331 103.506 147.459L94.4398 148.533C82.7327 149.919 73.5026 159.131 72.1135 170.815L71.0377 179.864C70.9093 180.941 69.341 180.941 69.2128 179.864L68.137 170.815C66.7479 159.131 57.5178 149.919 45.8105 148.533L36.7441 147.459C35.6634 147.331 35.6634 145.766 36.7441 145.638L45.8105 144.565C57.5178 143.178 66.7479 133.967 68.137 122.283L69.2128 113.235Z",
    fill: "#D2DBF5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M184.491 14.6735C184.598 13.7755 185.904 13.7755 186.011 14.6735L186.906 22.2066C188.063 31.9338 195.747 39.6031 205.494 40.7572L213.042 41.6511C213.943 41.7578 213.943 43.0606 213.042 43.1673L205.494 44.0612C195.747 45.2153 188.063 52.8846 186.906 62.6118L186.011 70.1448C185.904 71.0429 184.598 71.0429 184.491 70.1448L183.596 62.6118C182.439 52.8846 174.755 45.2153 165.008 44.0612L157.46 43.1673C156.56 43.0606 156.56 41.7578 157.46 41.6511L165.008 40.7572C174.755 39.6031 182.439 31.9338 183.596 22.2066L184.491 14.6735Z",
    fill: "#D2DBF5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M349.029 133.668C349.198 132.253 351.253 132.253 351.421 133.668L352.832 145.532C354.654 160.852 366.756 172.932 382.107 174.749L393.996 176.157C395.413 176.324 395.413 178.378 393.996 178.545L382.107 179.953C366.756 181.77 354.654 193.849 352.832 209.17L351.421 221.034C351.253 222.449 349.198 222.449 349.029 221.034L347.619 209.17C345.797 193.849 333.693 181.77 318.342 179.953L306.454 178.545C305.036 178.378 305.036 176.324 306.454 176.157L318.342 174.749C333.693 172.932 345.797 160.852 347.619 145.532L349.029 133.668Z",
    fill: "#D2DBF5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2561_10814",
    x: 135.483,
    y: 144.154,
    width: 156.606,
    height: 165.22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.34051,
    dy: 3.34051
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.01076
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2561_10814"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2561_10814",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2561_10814",
    x1: 215,
    y1: 372.5,
    x2: 215,
    y2: 420,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2561_10814",
    x1: 209.748,
    y1: 42.192,
    x2: 209.748,
    y2: 596.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankyou);
export default __webpack_public_path__ + "static/media/thankyou.9739a028188ebd95e4917b6384bcf4ee.svg";
export { ForwardRef as ReactComponent };